module.exports = __webpack_public_path__ + "media/common/images/badges/gray/vytrvalec-3969592cd507aecdff29245e0607b8b6.svg";